module.exports = __webpack_public_path__ + "img/Menu-06.de6cdaf1.png";